<template>
    <div class="infor">
        <div class="infor-list">
            <div class="item-title">
                <div class="item-title-text">{{channelData.title}} ({{channelData.begin_time}})</div>
                <div class="item-enter-live">
                    <el-button type="primary" size="small" @click="goClassroom" v-if="isShow">进入课堂</el-button>
                </div>
            </div>
            <div class="item-content">
                <el-form :inline="true" label-width="88px" label-position="left">
                    <div class="liveLink-from">
                        <el-form-item label="服务器地址：">
                            <el-input v-model="channelData.server_address" disabled style="width:600px;"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="text" :data-clipboard-text="channelData.server_address" class="clipboard" @click="copy">复制</el-button>
                        </el-form-item>
                    </div>
                    <div class="liveLink-from">
                        <el-form-item label="串流密钥：">
                            <el-input v-model="channelData.streaming_key" disabled style="width:600px;"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="text" :data-clipboard-text="channelData.streaming_key" class="clipboard" @click="copy">复制</el-button>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import Clipboard from 'clipboard'
import watchApi from '@/api/watch'
import { accountChannel } from '@/api/launch/index'
import { setAccountId, getAccountId, removeAccountId } from '@/utils/auth'

export default {
    inject: ['reload'],
    name: 'orgin',
    data() {
        return {
            channelId: '',
            channelData: {},
            accountId: '',
            isShow: true
        }
    },
    created() {
        this.channelId = this.$route.query.channel_id
        this.sessionId = this.$route.query.session_id
        this.$store.commit('getInfor', true)
        this.onload()
    },
    methods: {
        onload() {
            if (this.sessionId) {
                setAccountId(this.sessionId)
                this.$router.push({ path: '/infor', query: { channel_id: this.channelId } })
                this.getChannelDetail()
            } else {
                this.getChannelDetail()
            }
        },
        getAccountId() {
            this.accountId = getAccountId()
        },
        async getChannelDetail() {
            await this.getAccountId()
            watchApi.getChannelDetail(this.channelId, { role: 'teacher' }).then(res => {
                if (res.code === 0) {
                    if (!this.accountId) {
                        removeAccountId()
                        this.$router.push({
                            path: '/launch/login',
                            query: { channel_id: this.channelId }
                        })
                    } else {
                        this.accountChannel()
                    }
                }
            })
        },
        accountChannel() {
            accountChannel(this.channelId).then((res) => {
                if (res.code === 0) {
                    this.channelData = res.data
                }
            }).catch(() => {
                removeAccountId()
                this.$router.push({
                    path: '/launch/login',
                    query: { channel_id: this.channelId }
                })
            })
        },
        goClassroom() {
            this.$router.push({
                path: '/Launch',
                query: { channel_id: this.channelId }
            })
        },
        copy() {
            var clipboard = new Clipboard('.clipboard')
            clipboard.on('success', e => {
                this.$message({
                    type: 'success',
                    message: '复制成功'
                })
                clipboard.destroy()
            })
            clipboard.on('error', e => {
                this.$message({
                    type: 'error',
                    message: '该浏览器不支持复制'
                })
                clipboard.destroy()
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.infor-list{
    .item-title{
        position: relative;
        border-bottom: 1px solid #DCDFE6;
        padding: 23px 0;
        .item-title-text{
            font-size: 24px;
            color: #333;
            line-height: 32px;
            padding-right: 120px;
        }
        .item-enter-live{
            position: absolute;
            right: 0;
            top: 50%;
            transform: translate(0, -50%);
        }
    }
    .item-content{
        padding: 32px 0 10px;
    }
}
</style>
